module.exports = "/_next/static/images/AWS-67aae38b80818678b8423d9dda6fbd01.jpg";